<script lang="ts" setup>
</script>

<template>
    <div class="row iodine-padding-md references-detail-toolbar">
        <div class="references-detail-toolbar-button-group q-gutter-sm">
            <q-btn
                class="text-none iodine-icon-button iodine-button-outline"
                dense
                round
                outline
                flat
            >
                <q-icon
                    name="fa-solid fa-arrow-left"
                    class="iodine-small-icon"
                />
            </q-btn>
            <q-btn
                class="text-none iodine-icon-button iodine-button-outline"
                dense
                round
                outline
                flat
            >
                <q-icon
                    name="fa-solid fa-arrow-right"
                    class="iodine-small-icon"
                />
            </q-btn>
        </div>
        <div class="references-detail-heading iodine-padding-md iodine-sub-headline-large">
            TUBERCULOSIS
        </div>

        <q-btn
            class="text-none iodine-icon-button"
            round
            flat
        >
            <q-icon
                name="fa-regular fa-file"
                class="iodine-small-icon"
            />
        </q-btn>
        <q-btn
            class="text-none iodine-icon-button"
            round
            flat
        >
            <q-icon
                name="fa-solid fa-print"
                class="iodine-small-icon"/>
        </q-btn>

    </div>
</template>

<style lang="scss" scoped>
    .references-detail-toolbar-button-group {
        margin-top: 0;
        margin-left: 0;
    }
  .references-detail-toolbar {
      text-align: left;
    background-color: white;
    width: 100%;
  }
  .references-detail-heading {
      flex: auto;
  }
</style>
